import { get, post, put, del, getPage } from '@/utils/request'
import type { MockRule, MockServerInfo, MockHitLog } from '@/types'

/** Mock 规则列表 */
export const listMockRules = (params: {
  project_id: number
  page?: number
  page_size?: number
  keyword?: string
  method?: string
  enabled?: string
}) => getPage<MockRule>('/mocks', params)

/** Mock 服务信息（地址/端口/运行状态） */
export const getMockServerInfo = () =>
  get<MockServerInfo>('/mocks/server-info')

/** 最近命中日志 */
export const getRecentMockLogs = (limit = 100) =>
  get<MockHitLog[]>('/mocks/recent-logs', { limit })

/** 创建 Mock 规则 */
export const createMockRule = (data: {
  project_id: number
  name: string
  method: string
  path: string
  match_query?: string
  match_body?: string
  status_code?: number
  delay_ms?: number
  response_headers?: string
  body_type?: string
  response_body?: string
  description?: string
  enabled?: boolean
}) => post<MockRule>('/mocks', data)

/** 更新 Mock 规则 */
export const updateMockRule = (id: number, data: Partial<MockRule>, projectId: number) =>
  put<MockRule>(`/mocks/${id}`, data, { params: { project_id: projectId } })

/** 启用/停用 Mock 规则 */
export const toggleMockRule = (id: number, projectId: number) =>
  post<{ id: number; enabled: boolean }>(`/mocks/${id}/toggle`, null, { params: { project_id: projectId } })

/** 删除 Mock 规则 */
export const deleteMockRule = (id: number, projectId: number) =>
  del(`/mocks/${id}`, { params: { project_id: projectId } })
